export function externalShipmentAffValidate(external_shipment){
    var result = true;
    var errors = [];

    result = validateId(external_shipment.id, errors);
    
    if(!result) return errors;
    else return result;
}

function validateId(id, errors){    
    if(Number.isInteger(id)) return true;
    else { 
        errors.push("id_not_valid");
        return false;
    }
}